
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/not-a-joke-poweron-pro",
      function () {
        return require("private-next-pages/blog/not-a-joke-poweron-pro/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/not-a-joke-poweron-pro"])
      });
    }
  